interface AppLogoProps {
  size?: number;
  className?: string;
}

export default function AppLogo({
  size = 48,
  className = "",
}: AppLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Clean Pink Mail Envelope with rounded corners */}
      <rect
        x="4"
        y="12"
        width="40"
        height="28"
        rx="5"
        stroke="#E91E63"
        strokeWidth="3.2"
        fill="#E91E63"
        fillOpacity="0.12"
      />

      {/* Top flap line with rounded caps */}
      <path
        d="M4 14.5 L24 28 L44 14.5"
        stroke="#E91E63"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />

      {/* Bottom seams */}
      <path
        d="M5 38.5 L17.5 26"
        stroke="#E91E63"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
        opacity="0.5"
      />
      <path
        d="M43 38.5 L30.5 26"
        stroke="#E91E63"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
        opacity="0.5"
      />
    </svg>
  );
}
